import { render, staticRenderFns } from "./CreateNewSetupFees.vue?vue&type=template&id=301dcf67&scoped=true&"
import script from "./CreateNewSetupFees.vue?vue&type=script&lang=js&"
export * from "./CreateNewSetupFees.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewSetupFees.vue?vue&type=style&index=0&id=301dcf67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301dcf67",
  null
  
)

export default component.exports